export const certificationService = {
  getCertificationList,
  getCertificationByUserID,
  getAllCertificationStepByCID,
  downloadCertification,
  validateStep,
  uploadCertification,
  removeFile,
  addCarbonCreditRetirement,
  getCarbonCreditRetirementById,
  validateCNCApplication,
  updateCarbonCreditRetirement,
  validateCCRStep,
  rejectStep,
  sendStepToCOC,
  validateLastStep,
  rejectRetirementStep,
};

function getCertificationList() {
  return fetch(`${process.env.REACT_APP_API_URL}/certificate/allcertificates`)
    .then(handleResponse)
    .then((certifications) => {
      return certifications;
    });
}

function getCertificationByUserID(userId) {
  return fetch(
    `${process.env.REACT_APP_API_URL}/certificate/certificationbyuserid?id=${userId}`
  )
    .then(handleResponse)
    .then((certifications) => {
      return certifications;
    });
}

function getAllCertificationStepByCID(certificationId) {
  return fetch(
    `${process.env.REACT_APP_API_URL}/certificate/allstepbycertificationid?certificationId=${certificationId}`
  )
    .then(handleResponse)
    .then((certifications) => {
      return certifications;
    });
}

function downloadCertification(fileId) {
  return fetch(
    `${process.env.REACT_APP_API_URL}/downloadbyid?attachmentId=${fileId}`,
    {
      method: "GET",
    }
  )
    .then(async (response) => {
      const fileExtension = response.headers.get("X-File-Extension");
      const fileName = response.headers.get("X-File-Name");
      const contentType = response.headers.get("Content-Type");
      const arrayBuffer = await response.arrayBuffer();
      return {
        fileExtension,
        fileName,
        contentType,
        arrayBuffer,
      };
    })
    .then((data) => {
      const file = new File([data.arrayBuffer], `${data.fileName}`, {
        type: data.contentType,
      });
      const fileUrl = URL.createObjectURL(file);

      // Use the URL to create a link and trigger a download
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = `${data.fileName}${data.fileExtension}`; // Set the file name with extension
      link.click();

      // Clean up the blob URL
      URL.revokeObjectURL(fileUrl);
    });
}

function validateStep({
  stepId,
  certificationId,
  step,
  carbonCo2Value = null,
}) {
  const urlStep = `${process.env.REACT_APP_API_URL}/processusstep/validatebystepid?stepId=${stepId}&certificationId=${certificationId}&step=${step}`;
  const urlFinalStep = `${process.env.REACT_APP_API_URL}/processusstep/validatebystepid?stepId=${stepId}&certificationId=${certificationId}&step=${step}&carbonCo2Value=${carbonCo2Value}`;
  const requestOptions = {
    method: "POST",
  };
  const url = carbonCo2Value !== null ? urlFinalStep : urlStep;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function validateLastStep({ stepId, certificationId, step, totalCredit }) {
  const requestOptions = {
    method: "POST",
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/processusstep/validatecertification?stepId=${stepId}&certificationId=${certificationId}&step=${step}&totalCredit=${totalCredit}`,
    requestOptions
  )
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function rejectStep({ stepId, certificationId, step }) {
  const requestOptions = {
    method: "POST",
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/processusstep/rejectbystepid?stepId=${stepId}&certificatId=${certificationId}&step=${step}`,
    requestOptions
  )
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function rejectRetirementStep({ stepId, certificationId }) {
  const requestOptions = {
    method: "POST",
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/creditretirements/rejectretirementbyid?stepId=${stepId}&certificatId=${certificationId}`,
    requestOptions
  )
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function validateCCRStep({ stepId, certificationId }) {
  const requestOptions = {
    method: "POST",
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/creditretirements/validateretirementbyid?stepId=${stepId}&certificationId=${certificationId}`,
    requestOptions
  )
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function uploadCertification(uploadData) {
  const requestOptions = {
    method: "POST",
    body: uploadData,
  };

  return fetch(`${process.env.REACT_APP_API_URL}/upload`, requestOptions).then(
    handleResponse
  );
}

function removeFile(attachmentId) {
  const requestOptions = {
    method: "DELETE",
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/remove?attachmentId=${attachmentId}`,
    requestOptions
  ).then(handleResponse);
}

function addCarbonCreditRetirement(data) {
  var myHeaders = new Headers();
myHeaders.append("accept", "*/*");
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: data,
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/creditretirements/create-and-send-retirement-with-upload-list`,
    requestOptions
  )
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function getCarbonCreditRetirementById(ccrId) {
  console.log(`ccrID: ${ccrId}`);
  return fetch(
    `${process.env.REACT_APP_API_URL}/creditretirements/getretirementbyid?id=${ccrId}`
  )
    .then(handleResponse)
    .then((ccr) => {
      return ccr;
    });
}

function updateCarbonCreditRetirement(data, id) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const url = `${process.env.REACT_APP_API_URL}/creditretirements/update-retirement-by-certificationid?certificationId=${id}`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function validateCNCApplication(certificationId) {
  const requestOptions = {
    method: "POST",
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/certificate/validatebycoc?id=${certificationId}`,
    requestOptions
  )
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function sendStepToCOC({
  stepId,
  certificationId,
  step,
  carbonCo2Value,
}) {
  const requestOptions = {
    method: "POST",
  };
  const url = carbonCo2Value
    ? `${process.env.REACT_APP_API_URL}/processusstep/sendsteptococ?stepId=${stepId}&certificationId=${certificationId}&step=${step}&carbonCo2Value=${carbonCo2Value}`
    : `${process.env.REACT_APP_API_URL}/processusstep/sendsteptococ?stepId=${stepId}&certificationId=${certificationId}&step=${step}`;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((result) => {
      return result;
    });
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // if (response.status === 401) {
      //     // auto logout if 401 response returned from api
      //     return {'error': response.message}
      //     // logout();
      //     // location.reload(true);
      // }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
